import { Component, inject, signal, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService } from '../../core/services/toast.service';
import { SupportService } from '../../core/services/support.service';
import { SessionService } from '../../core/session.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './support.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  @Output() close = new EventEmitter<void>();

  private toastService = inject(ToastService);
  private supportService = inject(SupportService);
  private sessionService = inject(SessionService);
  private translate = inject(TranslateService);

  selectedObject = signal<string>('');
  message = signal<string>('');
  selectedEstablishment = signal<string>('');
  sending = signal<boolean>(false);
  establishments = signal<any[]>([]);

  objects = [
    { value: 'bug', label: 'support.objects.bug' },
    { value: 'feature', label: 'support.objects.feature' },
    { value: 'help', label: 'support.objects.help' },
    { value: 'account', label: 'support.objects.account' },
    { value: 'other', label: 'support.objects.other' }
  ];

  ngOnInit() {
    this.establishments.set(this.sessionService.establishments());
  }

  onClose() {
    this.close.emit();
  }

  onSubmit() {
    if (!this.selectedObject() || !this.message().trim()) {
      this.toastService.show(this.translate.instant('support.toast.fillAllFields'), 'warning');
      return;
    }

    this.sending.set(true);
    
    const payload: any = {
      object: this.selectedObject(),
      message: this.message()
    };
    
    if (this.selectedEstablishment()) {
      payload.establishment_id = this.selectedEstablishment();
    }
    
    this.supportService.sendMessage(payload).subscribe({
      next: (response) => {
        this.sending.set(false);
        const ticketInfo = response.ticket_id ? this.translate.instant('support.toast.ticketRef', { ref: response.ticket_id }) : '';
        this.toastService.show(this.translate.instant('support.toast.sentTitle'), 'success', 4000, this.translate.instant('support.toast.sentBody', { ticketInfo }));
        this.close.emit();
      },
      error: (err) => {
        this.sending.set(false);
        let errorMessage = this.translate.instant('support.toast.sendErrorTitle');
        let errorDetail = this.translate.instant('support.toast.sendErrorDefaultDetail');

        if (err.status === 400) {
          errorDetail = this.translate.instant('support.toast.error400');
        } else if (err.status === 401) {
          errorDetail = this.translate.instant('support.toast.error401');
        } else if (err.status === 403) {
          errorDetail = this.translate.instant('support.toast.error403');
        } else if (err?.error?.message) {
          errorDetail = err.error.message;
        }

        this.toastService.show(errorMessage, 'error', 5000, errorDetail);
      }
    });
  }
}